import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteErforderlichesDokumentCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteErforderlichesDokumentCommandService],
  exports: []
})
export class DeleteErforderlichesDokumentCommandServiceModule { }
